import { useMemo } from 'react';

export default function HeaderDate() {
  const formattedDate = useMemo(() => {
    const raw = new Date().toLocaleDateString('fr-FR', {
      weekday: 'short',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
    return raw
      .replace(/\./g, ' ')
      .split(' ')
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  }, []);

  return <p className="text-sm font-medium text-gray-500">{formattedDate}</p>;
}
